import { Outlet } from "react-router-dom";

const CampaignParentPage = () => {
    return <Outlet />
}
export default CampaignParentPage;
